export interface OfflinePlaybackModel {
  offlineCacheNotificationEnabled: boolean;
  wifiOnly: boolean;
  offlineCacheSizeResponse: { id?: number; name: string };
}
